"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "What types of events does Echelon Soiree curate?",
  answer: "We specialize in upscale soirées, high-profile corporate gatherings, and intimate private celebrations. Our studio is dedicated to those who seek a blend of sophisticated design and meticulous coordination for unforgettable experiences."
}, {
  question: "How do you approach the design of a bespoke event?",
  answer: "Our process is architectural and editorial in nature. We begin by understanding your aesthetic preferences and the desired atmosphere, then translate those into a cohesive visual narrative involving custom textures, lighting, and spatial layout."
}, {
  question: "Do you offer full-service planning or partial coordination?",
  answer: "Echelon Soiree is primarily a full-service boutique studio. We believe that seamless execution requires our involvement from the initial concept and venue selection through to on-site management and post-event wrap-up."
}, {
  question: "How far in advance should we secure your services?",
  answer: "To ensure the level of personalization and attention our clients expect, we recommend booking 6 to 12 months in advance for major celebrations. However, please reach out for shorter timelines as we occasionally have select openings."
}, {
  question: "Can you assist with global destination management?",
  answer: "Yes. While we are based locally, our team is equipped to manage logistics and curation for destination events worldwide, ensuring our signature 'Echelon' standard is maintained regardless of the location."
}];
export default function CommonInquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="52656" id="frequently-asked" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-20 left-20 w-96 h-96 bg-secondary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-64 h-64 bg-secondary/5 rounded-full blur-3xl" />
      </div>

      <div ref={ref} className={cn("relative z-10 container mx-auto px-6 md:px-12 lg:px-[200px] transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-serif font-light tracking-tight text-foreground">
            Frequently <span className="italic text-secondary-foreground/80">Asked</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans font-light tracking-wide">
            Refining the details of your next celebration. Explore our approach to 
            bespoke event curation and logistics.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4 max-w-3xl mx-auto">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border bg-card/30 backdrop-blur-sm rounded-none px-6 transition-all duration-300 hover:bg-card/60 hover:border-secondary/50">
              <AccordionTrigger className="text-foreground font-serif hover:text-secondary-foreground hover:no-underline py-6 text-xl font-normal [&[data-state=open]>svg]:text-secondary-foreground [&>svg]:transition-all [&>svg]:duration-300">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-sans font-light text-base leading-relaxed pb-6 tracking-wide">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-16 text-center">
          <p className="text-muted-foreground font-sans font-light mb-6 tracking-wider uppercase text-xs">
            Seeking a more personal consultation?
          </p>
          <Button asChild size="lg" className="rounded-none px-10 text-sm font-sans tracking-widest uppercase bg-transparent border border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-500 shadow-none">
            <Link to="/InquirePage">
              Inquire Now
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}